export default "__VITE_ASSET__B2cQtroe__"